jQuery(function($)
{
    var
        $body = $('body'),
        $foldDownContainers = $('.folddown'),
        /*
		 *	durationSlideUp = 300,
		 *	durationSlideDown = 300,
		 */
        minimalHeight = 400,
        listViewHeight = 100,
        { hide } = orion;

    // ------- Folddowns (Folddowns werden über ein Element ausgelöst, dessen data-target den zu öffnenden Folddown  referenziert)
    if (0 === $('.folddown-trigger').length)
    {
        return;
    }

    if ($foldDownContainers.hasClass('is-filter'))
    {
        if (localStorage.getItem('hide-filters') != 1)
        {
            $('.folddown.is-filter').addClass('opened');
        }
    }

    function foldUp($folddown)
    {
        $folddown
            .removeClass('opened')
            .trigger(orion.constants.EventFolddownClosed);
        /*
		 *$folddownMain
		 *	.slideUp({
		 *		"duration": durationSlideUp,
		 *		"done": function () {
		 *			$folddown
		 *				.removeClass("opened")
		 *				.trigger(orion.constants.EventFolddownClosed);
		 *		}
		 *	});
		 */

        if ($folddown.hasClass('is-filter'))
        {
            localStorage.setItem('hide-filters', 1);
        }
    }

    function foldDown($folddown)
    {
        $folddown
            .addClass('opened')
            .trigger(orion.constants.EventFolddownOpened);
        /*
		 * $folddownMain
		 * 	.slideDown({
		 * 		"duration": durationSlideDown,
		 * 		"done": function () {
		 * 			$folddown
		 * 				.addClass("opened")
		 * 				.trigger(orion.constants.EventFolddownOpened);
		 * 		}
		 * 	});
		 */

        if ($folddown.hasClass('is-filter'))
        {
            localStorage.setItem('hide-filters', 0);
        }
    }
    function handleRequestFoldup()
    {
        var
            $openFolddown = $('#' + $(this).data('target')),
            $folddownMain = $openFolddown;

        if ($folddownMain.hasClass('folddown-main'))
        {
            $folddownMain = $openFolddown.find('.folddown-main').eq(0);
        }

        foldUp($openFolddown, $folddownMain);
    }

    function handleRequestFolddown()
    {
        var
            $openFolddown = $('#' + $(this).data('target')),
            $folddownMain = $openFolddown;

        if (!$folddownMain.hasClass('folddown-main'))
        {
            $folddownMain = $openFolddown.find('.folddown-main').eq(0);
        }

        foldDown($openFolddown, $folddownMain);
    }

    function handleClickTrigger(e)
    {
        var
            $openFolddown = $('#' + $(this).data('target')),
            $folddownMain = $openFolddown,
            $this = $(this);

        if ($(this).is('a'))
        {
            e.preventDefault();
        }

        /*
		 * close all folddowns except the one that should open
		 * $(".folddown:not(" + $openFolddown['selector'] + ")").removeClass('opened');
		 */

        if (!$folddownMain.hasClass('folddown-main'))
        {
            $folddownMain = $openFolddown.find('.folddown-main').eq(0);
        }

        if ($openFolddown.hasClass('opened'))
        {
            if ($this.data('lang') === 'en')
            {
                $this.html('Show more');
            }
            else if ($this.data('lang') === 'de')
            {
                $this.html('Mehr anzeigen');
            }
            $('.dropdown', $openFolddown).not('.hidden')
                .each(function(idx, el)
                {
                    hide($(el));
                });
            $('.dropdown-trigger', $openFolddown).each(function(idx, el)
            {
                $(el).removeClass('primary');
            });
            foldUp($openFolddown, $folddownMain);
            if ($openFolddown.hasClass('folddown-mobile'))
            {
                $(this).trigger(orion.constants.EventFolddownMobileOpening);
            }
        }
        else
        {
            foldDown($openFolddown, $folddownMain);
            if ($this.data('lang') === 'en')
            {
                $this.html('Close');
            }
            else if ($this.data('lang') === 'de')
            {
                $this.html('Einklappen');
            }
            if ($openFolddown.hasClass('folddown-mobile'))
            {
                $(this).trigger(orion.constants.EventFolddownMobileOpening);
            }
        }
    }

    function handleClickClose(e)
    {
        console.log('folddown.js handleClickClose()');
        e.preventDefault();
        foldUp($(this).parent('.folddown'), $(this).parent('.folddown-main'));
    }

    $foldDownContainers.each(function()
    {
        var folddownIndicator = false;

        if ($(this).find('.folddown-height').length)
        {
            if ($(this).find('.folddown-height')
                .outerHeight() <= minimalHeight)
            {
                folddownIndicator = true;
            }
        }

        if ($(this).find('.folddown-height--list-view').length)
        {
            if ($(this).find('.folddown-height--list-view')
                .outerHeight() <= listViewHeight)
            {
                folddownIndicator = true;
            }
        }

        if (folddownIndicator)
        {
            $(this).addClass('opened');
            $(this).next('.folddown-trigger')
                .hide();
        }
    });

    $body
        .on('click', '.folddown-trigger', handleClickTrigger)
        .on(orion.constants.EventFoldupRequested, '.folddown-trigger', handleRequestFoldup)
        .on(orion.constants.EventFolddownRequested, '.folddown-trigger', handleRequestFolddown);

    $('.folddown').on('click', '.close', handleClickClose);

    $('.folddown.opened').not('#shoppinglist')
        .show();
});
